<template>
    <div class="mysubscribe_page">
        <el-table
        :data="subscribeList"
        style="width: 100%"
        size="mini"
        v-loading="table_loading">
            <el-table-column
                prop="room.name"
                label="会议室"
                width="180">
            </el-table-column>
            <el-table-column
                prop="start_time"
                label="开始时间"
                width="180">
            </el-table-column>
            <el-table-column
                prop="end_time"
                label="结束时间">
            </el-table-column>
            <el-table-column
                prop="theme"
                label="会议主题">
            </el-table-column>
            <el-table-column
                prop="organizer"
                label="主办单位">
            </el-table-column>
            <el-table-column
                prop="contacts"
                label="联系人">
            </el-table-column>
            <el-table-column
                prop="contacts_number"
                label="联系电话">
            </el-table-column>
            <el-table-column
                prop="status"
                label="状态">
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.status=='1'? true:false" type="primary" disable-transitions>审批中</el-tag>
                    <el-tag v-if="scope.row.status=='2'? true:false" type="success" disable-transitions>通过审批</el-tag>
                    <el-tag v-if="scope.row.status=='3'? true:false" type="danger" disable-transitions>拒绝审批</el-tag>
                    <el-tag v-if="scope.row.status=='4'? true:false" type="info" disable-transitions>会议结束</el-tag>
                    <el-tag v-if="scope.row.status=='5'? true:false" type="warning" disable-transitions>取消预约</el-tag>
                </template>
            </el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button @click="updateHandle(scope.row)" type="text" size="small">修改</el-button>
                    <el-button v-if="scope.row.status=='2'" @click="cancelHandle(scope.row)" type="text" size="small">取消</el-button>
                    <el-button v-if="scope.row.status=='2'" @click="endHandle(scope.row)" type="text" size="small">结束</el-button>
                    <el-button @click="deleteHandle(scope.row)" type="text" size="small">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            background
            layout="prev, pager, next"
            :total="total"
            :page-size="10"
            :current-page="currentPage"
            class="page_pagination"
            @next-click="handlePageChange"
            @prev-click="handlePageChange"
            @current-change="handlePageChange"
            >
        </el-pagination>
        <el-dialog title="修改信息" :visible.sync="updateInfoFormVisible" width="30%">
            <el-form :model="updateInfo" label-width="80px">
                <el-form-item label="会议主题">
                    <el-input v-model="updateInfo.theme" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="主办单位">
                    <el-input v-model="updateInfo.organizer" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="联系人">
                    <el-input v-model="updateInfo.contacts" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="联系电话">
                    <el-input v-model="updateInfo.contacts_number" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="updateInfoFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="updateInfoHandle">提 交</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    data(){
        return{
            subscribeList: [],
            total: null,
            currentPage: 1,
            table_loading: false,
            updateId: null,
            updateInfoFormVisible: false,
            updateInfo:{
                theme: '',
                organizer: '',
                contacts: '',
                contacts_number: '',
            }
        }
    },
    mounted(){
        this.getSubscribeList()
    },
    methods:{
        getSubscribeList(page){
            this.table_loading = true
            let url = null
            if (page) {
                url = '/subscribe/me/?page=' + page
            } else {
                url = '/subscribe/me/'
            }
            this.$axios.get(url)
            .then(res => {
                if (res.status === 1) {
                    this.subscribeList = res.data
                    this.total = res.total
                }
            })
            this.table_loading = false
        },
        deleteHandle(row){
            let id = row.id
            this.$confirm('确认删除吗？')
            .then(() => {
                this.$axios.delete('/subscribe/'+id+'/')
                .then(res => {
                    if (res.status === 1){
                        const index = this.subscribeList.findIndex((value) => value.id == id)
                        if (index != -1) {
                            this.subscribeList.splice(index,1)
                        }
                        this.$message.success('删除成功')
                    } else {
                        this.$message.error(res.msg)
                    }
                })
            })
            .catch(res => {
                this.$message.info('已取消')
                console.log(res)
            })
        },
        handlePageChange(page){
            this.getSubscribeList(page)
        },
        updateHandle(row){
            this.updateId = row.id
            this.updateInfo.theme = row.theme
            this.updateInfo.organizer = row.organizer
            this.updateInfo.contacts = row.contacts
            this.updateInfo.contacts_number = row.contacts_number
            this.updateInfoFormVisible = true
        },
        cancelHandle(row){
            this.$confirm('确认取消预约吗？')
            .then(() => {
                let id = row.id
                this.$axios.post('/subscribe/cancel/', {
                    id: id
                })
                .then(res => {
                    if (res.status === 1){
                        this.$message.success('预约取消成功')
                    } else {
                        this.$message.error(res.msg)
                    }
                })
            })
            .catch(res => {
                this.$message.info('已取消')
                console.log(res)
            })
        },
        updateInfoHandle(){
            if (!this.updateInfo.theme) {
                this.$message.error('会议主题不能为空')
                return false
            } else if (!this.updateInfo.organizer) {
                this.$message.error('主办单位不能为空')
                return false
            } else if (!this.updateInfo.contacts){
                this.$message.error('联系人不能为空')
                return false
            } else if (!this.updateInfo.contacts_number){
                this.$message.error('联系电话不能为空')
                return false
            }
            this.$confirm('确认提交吗？')
            .then(() => {
                let id = this.updateId
                this.$axios.put('/subscribe/'+id+'/',this.updateInfo)
                .then(res => {
                    if (res.status === 1){
                        this.$message.success('修改成功')
                        this.updateInfoFormVisible = false
                    } else {
                        this.$message.error(res.msg)
                    }
                })
            })
            .catch(res => {
                this.$message.info('已取消')
                console.log(res)
            })
        },
        endHandle(row){
            this.$confirm('确认结束预约吗？')
            .then(() => {
                let id = row.id
                this.$axios.post('/subscribe/end/', {
                    id: id
                })
                .then(res => {
                    if (res.status === 1){
                        this.$message.success('预约结束成功')
                    } else {
                        this.$message.error(res.msg)
                    }
                })
            })
            .catch(res => {
                this.$message.info('已取消')
                console.log(res)
            })
        }
    }
}
</script>
<style lang="less" scoped>
.mysubscribe_page{
    .page_pagination{
        text-align: center;
        margin-top: 50px;
    }
}
</style>